import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/merchandise/listing.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getMerchandiseProducts = (_0) => __async(void 0, [_0], function* ({
  lang,
  authorIds,
  tags,
  page = 1,
  perPage = 6
}) {
  try {
    const locale = getLocaleOnly(lang);
    const params = new URLSearchParams({
      lang: locale,
      page: page.toString(),
      per_page: perPage.toString()
    });
    if (authorIds == null ? void 0 : authorIds.length) {
      params.append("author_ids", authorIds.join(","));
    }
    if (tags == null ? void 0 : tags.length) {
      params.append("tags", tags.join(","));
    }
    const data = yield fetchClient({
      url: `/webook-shop/event-products?${params.toString()}`
    });
    return data.data || [];
  } catch (error) {
    throw new Exception({
      error,
      name: "getMerchandiseProductsException",
      context: { extra: { authorIds, tags } }
    });
  }
});

export {
  getMerchandiseProducts
};
//# sourceMappingURL=chunk-NX7DX2HC.mjs.map